module.exports = __webpack_public_path__ + "static/media/iconSearch.14fae881.svg";